import { render } from "./PrimaryBtn.vue?vue&type=template&id=773bd7ab&scoped=true"
import script from "./PrimaryBtn.vue?vue&type=script&lang=js"
export * from "./PrimaryBtn.vue?vue&type=script&lang=js"

import "./PrimaryBtn.vue?vue&type=style&index=0&id=773bd7ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773bd7ab"]])

export default __exports__